var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 *
 * @author Matthew Rawson @ 21/11/2018 14:22
 * @description
 * @notes
 */
import React, { Fragment, PureComponent } from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import { get, isEmpty } from "lodash";
import getId from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import Select from "@irati/ui/src/FormItem/Select";
import connect from "@irati/store/connect";
import padding from "@irati/ui/src/global/padding";
import ScheduleQuery from "@irati/insights/apollo/query/schedule/get";
import { AccordionItem } from "@irati/ui/src/Accordion";
import { ReportsContext } from "@irati/insights/context";
import { overrideAuth } from "@irati/insights/utils/apollo";
import ListFilter from "../ListFilter/ListFilter";
import CreateReportFooter from "./CreateReportFooter";
import ReportActions from "../../store/actions/report";
var SelectList = styled(Select)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 300px;\n"], ["\n  width: 300px;\n"])));
var ScheduleRow = styled(Row)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.small);
var MIN_RESPONSES = 5;
var CreateReport = /** @class */ (function (_super) {
    __extends(CreateReport, _super);
    function CreateReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            formattedMessages: { accordionTitle: "" },
            scheduleValue: null,
            filters: {}
        };
        _this.accordion = React.createRef();
        _this.generateFormattedMessages = function (setToState) {
            if (setToState === void 0) { setToState = true; }
            var formatMessage = _this.props.formatMessage;
            var formattedMessages = {
                accordionTitle: formatMessage({ id: "insights.reports.create.title" })
            };
            if (setToState)
                _this.setState({ formattedMessages: formattedMessages });
            return formattedMessages;
        };
        _this.handleChange = function (value, scheduleValue) {
            _this.setState({ scheduleValue: scheduleValue });
        };
        _this.handleFilterChange = function (filters) {
            _this.setState({ filters: filters });
        };
        _this.getScheduleQueryVariables = function (_a) {
            var tenant = _a.tenantId, id = _a.scheduleId;
            var filters = _this.state.filters;
            var team = filters.teamId, minOpenedAt = filters.time, driverId = filters.driverId;
            return {
                tenant: tenant,
                id: id,
                team: team,
                driverId: driverId,
                minOpenedAt: minOpenedAt,
                withResponseCount: true,
                withFirstSurvey: true
            };
        };
        _this.handleMutationCompleted = function (_a, isDemo) {
            var uuid = _a.createReport.uuid;
            var _b = _this.props, addPendingReport = _b.addPendingReport, loadingReports = _b.loadingReports;
            _this.accordion.current.close();
            addPendingReport(uuid, isDemo);
            loadingReports(false);
        };
        return _this;
    }
    CreateReport.prototype.componentDidMount = function () {
        this.generateFormattedMessages();
        var current = this.accordion.current;
        if (current)
            current.open();
    };
    CreateReport.prototype.render = function () {
        var _this = this;
        var idNamespace = getId("CreateReportAccordionItem", this.props);
        var _a = this.state, formattedMessages = _a.formattedMessages, scheduleValue = _a.scheduleValue, filters = _a.filters;
        var loadingReports = this.props.loadingReports;
        return (React.createElement(AccordionItem, { id: idNamespace, ref: this.accordion, title: formattedMessages.accordionTitle },
            React.createElement(ReportsContext.Consumer, null, function (_a) {
                var schedules = _a.schedules, scheduleOptions = _a.scheduleOptions, allTeams = _a.allTeams, tenantId = _a.tenantId, locationFilters = _a.filters, isDemo = _a.isDemo, demoTenantAccessToken = _a.demoTenantAccessToken;
                var selectedScheduleId = scheduleValue ? scheduleValue.value : locationFilters.scheduleId;
                var selectedScheduleOption = scheduleOptions.find(function (_a) {
                    var value = _a.value;
                    return value === selectedScheduleId;
                });
                var activeSchedule = schedules.find(function (_a) {
                    var id = _a.id;
                    return id === selectedScheduleId;
                });
                var teamsSentTo = get(activeSchedule, "teamsSentTo.results");
                var teams = isEmpty(teamsSentTo) ? allTeams : teamsSentTo;
                return (React.createElement(ScheduleQuery, __assign({ variables: _this.getScheduleQueryVariables({ tenantId: tenantId, scheduleId: selectedScheduleId }), notifyOnNetworkStatusChange: true, skip: !selectedScheduleId, useLoader: false }, overrideAuth(demoTenantAccessToken, isDemo)), function (_a) {
                    var schedule = _a.schedule, loading = _a.loading;
                    var isFilteredByTeam = !!filters.teamId;
                    var minResponseCount = !isFilteredByTeam || (isFilteredByTeam && schedule.responseCount >= MIN_RESPONSES);
                    var isButtonDisabled = true;
                    if (!isEmpty(activeSchedule))
                        isButtonDisabled = !activeSchedule.lastTriggeredAt || !minResponseCount;
                    return (React.createElement(Fragment, null,
                        React.createElement(ScheduleRow, null,
                            React.createElement(SelectList, { id: getId("Schedule", idNamespace), name: "schedule", label: "Survey", options: scheduleOptions, value: selectedScheduleOption, isClearable: false, onChange: _this.handleChange })),
                        !isEmpty(activeSchedule) && (React.createElement(ListFilter, { id: idNamespace, hasTime: true, values: locationFilters, drivers: activeSchedule.drivers.results, teams: teams, onChange: _this.handleFilterChange })),
                        React.createElement(CreateReportFooter, { schedule: schedule, isDisabled: isButtonDisabled, isLoading: loading, minResponseCount: minResponseCount, filters: filters, onBeforeCreate: function () { return loadingReports(true); }, onCompleted: _this.handleMutationCompleted })));
                }));
            })));
    };
    return CreateReport;
}(PureComponent));
var mapDispatchToProps = function (dispatch) {
    return {
        addPendingReport: function (uuid, isDemo) { return dispatch(ReportActions.addPending(uuid, isDemo)); }
    };
};
export default connect(null, mapDispatchToProps)(injectIntl(CreateReport));
var templateObject_1, templateObject_2;
